/**
 * TotmArchivePage — "Misc → TOTM Archive": embeds the pre-built Reefkeeping
 * Tank-of-the-Month archive (81 features, ~5,400 photos) in a full-height
 * iframe. The archive is too large for git/the web build, so it is hosted
 * on the Pi at /home/josh/REEF-APP-MEDIA/totm/ and served by nginx at `/totm/`.
 * `piAssetUrl` points the iframe at the Pi's origin when the app itself is
 * hosted elsewhere (Vercel).
 */
import { piAssetUrl } from '../lib/env';

export function TotmArchivePage() {
  return (
    <div className="h-[calc(100vh-7rem)] w-full md:h-[calc(100vh-4rem)]">
      <iframe
        src={piAssetUrl('/totm/')}
        title="Reefkeeping Tank of the Month Archive"
        className="h-full w-full border-0"
      />
    </div>
  );
}
